// this is wrong namely it is not related at all to react.
import { hotjar } from 'react-hotjar';
var ID;
var VERSION;
var isUserInteractionTrackerInitialized;
export var initializeUserInteractionTracker = function initializeUserInteractionTracker(_ref) {
  var hotjarCredentials = _ref.credentials;
  if (!hotjarCredentials) {
    throw Error('credentials are mandatory');
  }
  if (!isUserInteractionTrackerInitialized) {
    ID = hotjarCredentials.id;
    VERSION = hotjarCredentials.version;
    isUserInteractionTrackerInitialized = true;
    hotjar.initialize(ID, VERSION);
  }
};